/**
 * Catalogue Admin — picker « Produit lié pour le stock » (Slice C).
 * Chargement paginé dédié : n'affecte pas Mes Produits / ProduitsManager.
 */

/** Max autorisé par l'API GET /produits/commercant/:id (HARD LIMIT backend). */
export const LINKED_PRODUIT_PICKER_PAGE_SIZE = 50;

/**
 * Récupère toutes les pages du catalogue commerçant pour le picker linkedProduitId.
 * @param {function(string, boolean, object): Promise<object|array>} getProduitsByCommercant
 * @param {string} commercantId
 * @returns {Promise<object[]>}
 */
export async function fetchAllCommercantProduitsForPicker(
  getProduitsByCommercant,
  commercantId
) {
  if (!commercantId) return [];

  const all = [];
  let page = 1;
  let totalPages = 1;

  while (page <= totalPages) {
    const response = await getProduitsByCommercant(commercantId, true, {
      page,
      pageSize: LINKED_PRODUIT_PICKER_PAGE_SIZE,
    });

    const batch = Array.isArray(response) ? response : response?.produits || [];

    if (batch.length === 0) {
      break;
    }

    all.push(...batch);

    if (typeof response?.pages === 'number') {
      totalPages = response.pages;
    } else if (typeof response?.total === 'number') {
      totalPages = Math.ceil(response.total / LINKED_PRODUIT_PICKER_PAGE_SIZE) || 1;
    } else if (batch.length < LINKED_PRODUIT_PICKER_PAGE_SIZE) {
      break;
    } else {
      totalPages = page + 1;
    }

    page += 1;
  }

  return all;
}

/**
 * Produits éligibles au picker linkedProduitId (même commerçant imposé par l'endpoint).
 * - actifs et inactifs : oui (référence catalogue ; un lié inactif rend l'option indisponible)
 * - indisponibles : oui
 * - produit parent courant : exclu (auto-référence interdite)
 * - supprimés/archivés : absents de l'API Prisma
 * @param {object[]} produits
 * @param {{ excludeProduitId?: string|null }} options
 * @returns {object[]}
 */
export function buildLinkedProduitPickerOptions(produits, { excludeProduitId = null } = {}) {
  if (!Array.isArray(produits)) return [];

  return produits.filter((p) => {
    if (!p?.id) return false;
    if (excludeProduitId && p.id === excludeProduitId) return false;
    return true;
  });
}
